import { ChevronLeft, ChevronRight } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const MODES = [["month", "Month"], ["quarter", "Quarter"], ["ytd", "Year to Date"], ["last_year", "Last Year"]];

// Returns {params, label, canNext} for the API from a mode + offset (0 = current period).
export const periodFor = (mode, offset) => {
  const now = new Date();
  if (mode === "month") {
    const d = new Date(now.getFullYear(), now.getMonth() + offset, 1);
    return { params: { month: `${d.getFullYear()}-${pad(d.getMonth() + 1)}` }, canNext: offset < 0, label: null };
  }
  if (mode === "quarter") {
    const q0 = Math.floor(now.getMonth() / 3) + offset;
    const start = new Date(now.getFullYear(), q0 * 3, 1);
    const end = new Date(start.getFullYear(), start.getMonth() + 3, 1);
    const label = `Q${Math.floor(start.getMonth() / 3) + 1} ${start.getFullYear()}`;
    return { params: { start: ymd(start), end: ymd(end), label }, canNext: offset < 0, label };
  }
  if (mode === "ytd") {
    const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const label = `${now.getFullYear()} Year to Date`;
    return { params: { start: `${now.getFullYear()}-01-01`, end: ymd(tomorrow), label }, canNext: false, label };
  }
  const y = now.getFullYear() - 1;
  return { params: { start: `${y}-01-01`, end: `${y + 1}-01-01`, label: `${y}` }, canNext: false, label: `${y}` };
};

export const PeriodPicker = ({ mode, offset, label, onMode, onOffset }) => {
  const { canNext } = periodFor(mode, offset);
  const steppable = mode === "month" || mode === "quarter";
  return (
    <div className="bg-white rounded-xl border p-3 space-y-3">
      <div className="grid grid-cols-4 gap-1 p-1 bg-zinc-100 rounded-lg" data-testid="period-mode">
        {MODES.map(([k, l]) => (
          <button key={k} onClick={() => onMode(k)} data-testid={`period-${k}`}
            className={`h-8 rounded-md text-[11px] sm:text-xs font-semibold ${mode === k ? "bg-white text-zinc-900 shadow-sm" : "text-zinc-500"}`}>
            {l}
          </button>
        ))}
      </div>
      <div className="flex items-center justify-between">
        <button onClick={() => onOffset(offset - 1)} disabled={!steppable}
          className="p-2 hover:bg-zinc-100 rounded-lg disabled:opacity-0" data-testid="prev-month">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <span className="font-semibold text-lg text-zinc-900" data-testid="current-month">{label}</span>
        <button onClick={() => onOffset(offset + 1)} disabled={!steppable || !canNext}
          className="p-2 hover:bg-zinc-100 rounded-lg disabled:opacity-30" data-testid="next-month">
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};
